var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reservation-landing-page-builder" }, [
    _c(
      "div",
      { staticClass: "route-page-content breadcrumb-content" },
      [
        _c("SidebarChild", {
          attrs: {
            items: _vm.menuItems,
            "selected-item": _vm.currentPage,
            focusActive: true,
          },
          on: { selected: _vm.fnClicked, clicked: _vm.fnClicked },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-content-wrapper" },
          [
            _vm.loading
              ? _c("div", { staticClass: "loading" }, [
                  _vm._v(_vm._s(_vm.$t("message.loading")) + "..."),
                ])
              : !_vm.data
              ? _c(
                  "div",
                  { staticClass: "no-data" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        staticClass: "create-button",
                        on: { click: _vm.createMockLandingPage },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("calendar.setupBookingWebsite")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "builder-content" }, [
                  _c(
                    "div",
                    { staticClass: "builder-header" },
                    [
                      _c("h1", { staticClass: "page-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("calendar.bookingLandingPageBuilder"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "preview-button",
                          on: { click: _vm.openPreview },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("visibility"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("chatbotv2.preview")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "builder-content" }, [
                    _c("div", { staticClass: "logo-cover-container" }, [
                      _c("section", { staticClass: "builder-section logo" }, [
                        _c("h2", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(_vm.$t("message.logo"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "logo-container",
                              on: {
                                mouseover: function ($event) {
                                  _vm.showOverlay = true
                                },
                                mouseleave: function ($event) {
                                  _vm.showOverlay = false
                                },
                                click: _vm.selectLogo,
                              },
                            },
                            [
                              _vm.data.logo
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.getImageUrl(_vm.data.logo),
                                      alt: "Logo",
                                    },
                                  })
                                : _c("span", { staticClass: "no-logo" }, [
                                    _vm._v(_vm._s(_vm.$t("message.noLogo"))),
                                  ]),
                              _vm._v(" "),
                              _vm.showOverlay
                                ? _c("div", { staticClass: "overlay" }, [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("edit"),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "builder-section coverPhoto" },
                        [
                          _c("h2", { staticClass: "section-title" }, [
                            _vm._v(_vm._s(_vm.$t("calendar.coverPhoto"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "coverPhoto-container",
                                on: {
                                  mouseover: function ($event) {
                                    _vm.showCoverOverlay = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showCoverOverlay = false
                                  },
                                  click: _vm.selectCover,
                                },
                              },
                              [
                                _vm.data.coverPhoto
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.getImageUrl(
                                          _vm.data.coverPhoto
                                        ),
                                        alt: "Kapak Fotoğrafı",
                                      },
                                    })
                                  : _c(
                                      "span",
                                      { staticClass: "no-coverPhoto" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("calendar.noCoverPhoto")
                                          )
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _vm.showCoverOverlay
                                  ? _c("div", { staticClass: "overlay" }, [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("edit")]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "section",
                        { staticClass: "builder-section coverPhoto" },
                        [
                          _c("h2", { staticClass: "section-title" }, [
                            _vm._v(_vm._s(_vm.$t("message.backgroundPhoto"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "coverPhoto-container",
                                on: {
                                  mouseover: function ($event) {
                                    _vm.showBackgroundOverlay = true
                                  },
                                  mouseleave: function ($event) {
                                    _vm.showBackgroundOverlay = false
                                  },
                                  click: _vm.selectBackground,
                                },
                              },
                              [
                                _vm.data.backgroundImage
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.getImageUrl(
                                          _vm.data.backgroundImage
                                        ),
                                        alt: "Arka Plan Fotoğrafı",
                                      },
                                    })
                                  : _c(
                                      "span",
                                      { staticClass: "no-coverPhoto" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("calendar.noCoverPhoto")
                                          )
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _vm.showBackgroundOverlay
                                  ? _c("div", { staticClass: "overlay" }, [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("edit")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "i",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: { color: "red" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.removeBackgroundImage.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("delete")]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "builder-section" }, [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(_vm._s(_vm.$t("calendar.organizationName"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-content" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.organizationName,
                              expression: "data.organizationName",
                            },
                          ],
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t(
                              "calendar.enterOrganizationName"
                            ),
                          },
                          domProps: { value: _vm.data.organizationName },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "organizationName",
                                _vm.data.organizationName
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "organizationName",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "builder-section" }, [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("calendar.about")) +
                            "\n                            "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t(
                                    "message.whenYouActivateFeature"
                                  ),
                                },
                                expression:
                                  "{\n                                    content: $t('message.whenYouActivateFeature'),\n                                }",
                              },
                            ],
                            staticClass: "md-icon",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleVisibility("about")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.isSectionVisible("about")
                                    ? "disabled_visible"
                                    : "visibility"
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "section-content" },
                        [
                          _c("quill-editor", {
                            staticClass: "quill-editor",
                            attrs: {
                              options: _vm.editorOption,
                              placeholder: _vm.$t("calendar.enterAboutInfo"),
                            },
                            model: {
                              value: _vm.data.about,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "about", $$v)
                              },
                              expression: "data.about",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "builder-section" }, [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("calendar.service")) +
                            "\n                            "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t(
                                    "message.whenYouActivateFeature"
                                  ),
                                },
                                expression:
                                  "{\n                                   content: $t('message.whenYouActivateFeature'),\n                                }",
                              },
                            ],
                            staticClass: "md-icon",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleVisibility("services")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.isSectionVisible("services")
                                    ? "disabled_visible"
                                    : "visibility"
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "section-content" },
                        [
                          _vm._l(_vm.data.services, function (service, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "service-group" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "service-header" },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        attrs: { contenteditable: "true" },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.updateServiceName(
                                              index,
                                              $event.target.innerText
                                            )
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return $event.target.blur()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(service.groupName) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { danger: "", ghost: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeService(index)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("calendar.deleteServices")
                                          ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "pl-5" },
                                  _vm._l(service.plans, function (plan) {
                                    return _c(
                                      "li",
                                      { key: plan._id },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-flex gap-5 align-center",
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("event")]
                                            ),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(_vm.getPlanName(plan)) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "SupsisButton",
                                          {
                                            attrs: { ghost: "", danger: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removePlan(
                                                  service,
                                                  plan
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t("message.delete")
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "pl-5" },
                                  _vm._l(service.users, function (userId) {
                                    return _c(
                                      "li",
                                      { key: userId },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-flex gap-5 align-center",
                                          },
                                          [
                                            _vm.getTeamMember(userId).avatar
                                              ? _c("img", {
                                                  staticClass: "avatar",
                                                  attrs: {
                                                    src: _vm.getAvatarUrl(
                                                      _vm.getTeamMember(userId)
                                                        .avatar
                                                    ),
                                                    alt: "Avatar",
                                                  },
                                                })
                                              : _c(
                                                  "span",
                                                  { staticClass: "no-avatar" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "calendar.noAvatar"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.getTeamMember(userId).name
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "SupsisButton",
                                          {
                                            attrs: { ghost: "", danger: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeUser(
                                                  service,
                                                  userId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t("message.delete")
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      gap: "20px",
                                    },
                                  },
                                  [
                                    _c("CustomPicker", {
                                      attrs: {
                                        items: _vm.allPlans,
                                        idKey: "_id",
                                        labelKey: "title",
                                        title: _vm.$t(
                                          "calendar.selectReservationPlan"
                                        ),
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.addPlan(service, $event)
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        items: _vm.data.team,
                                        idKey: "_id",
                                        labelKey: "name",
                                        title: _vm.$t("message.addTeamMember"),
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.addUserToService(
                                            service,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: { primary: "" },
                              on: { click: _vm.addService },
                            },
                            [
                              _vm._v(
                                "+ " + _vm._s(_vm.$t("calendar.addNewService"))
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "builder-section" }, [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("message.team")) +
                            "\n                            "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t(
                                    "message.whenYouActivateFeature"
                                  ),
                                },
                                expression:
                                  "{\n                                    content: $t('message.whenYouActivateFeature'),\n                                }",
                              },
                            ],
                            staticClass: "md-icon",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleVisibility("team")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.isSectionVisible("team")
                                    ? "disabled_visible"
                                    : "visibility"
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "section-content team-section" },
                        [
                          _vm._l(_vm.data.team, function (member, index) {
                            return _c("ReservationMemberCard", {
                              key: index,
                              attrs: { member: member },
                              on: {
                                edit: function ($event) {
                                  return _vm.editMember(index)
                                },
                                delete: function ($event) {
                                  return _vm.deleteMember(index)
                                },
                                "move-up": function ($event) {
                                  return _vm.moveMemberUp(index)
                                },
                                "move-down": function ($event) {
                                  return _vm.moveMemberDown(index)
                                },
                              },
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "add-member-card",
                              on: { click: _vm.addMockMember },
                            },
                            [
                              _vm._v(
                                "\n                                + " +
                                  _vm._s(_vm.$t("calendar.addNewMember")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "builder-section" }, [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("message.address")) +
                            "\n                            "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  content: _vm.$t(
                                    "message.whenYouActivateFeature"
                                  ),
                                },
                                expression:
                                  "{\n                                    content: $t('message.whenYouActivateFeature'),\n                                }",
                              },
                            ],
                            staticClass: "md-icon",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleVisibility("address")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.isSectionVisible("address")
                                    ? "disabled_visible"
                                    : "visibility"
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-content" }, [
                        _c("label", { attrs: { for: "fullAddress" } }, [
                          _vm._v(_vm._s(_vm.$t("calendar.fullAddress"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.address.fullAddress,
                              expression: "data.address.fullAddress",
                            },
                          ],
                          attrs: {
                            id: "fullAddress",
                            type: "text",
                            placeholder: _vm.$t("calendar.enterFullAddress"),
                          },
                          domProps: { value: _vm.data.address.fullAddress },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "address.fullAddress",
                                _vm.data.address.fullAddress
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.address,
                                "fullAddress",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "googleMapsUrl" } }, [
                          _vm._v("Google Maps URL"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.address.googleMapsUrl,
                              expression: "data.address.googleMapsUrl",
                            },
                          ],
                          attrs: {
                            id: "googleMapsUrl",
                            type: "text",
                            placeholder: _vm.$t("calendar.enterGoogleMapsURL"),
                          },
                          domProps: { value: _vm.data.address.googleMapsUrl },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "address.googleMapsUrl",
                                _vm.data.address.googleMapsUrl
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.address,
                                "googleMapsUrl",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "latitude" } }, [
                          _vm._v(_vm._s(_vm.$t("calendar.latitude"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.address.latitude,
                              expression: "data.address.latitude",
                            },
                          ],
                          attrs: {
                            id: "latitude",
                            type: "number",
                            placeholder: _vm.$t("calendar.enterLatitude"),
                          },
                          domProps: { value: _vm.data.address.latitude },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "address.latitude",
                                _vm.data.address.latitude
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.address,
                                "latitude",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "longitude" } }, [
                          _vm._v(_vm._s(_vm.$t("calendar.longitude"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.address.longitude,
                              expression: "data.address.longitude",
                            },
                          ],
                          attrs: {
                            id: "longitude",
                            type: "number",
                            placeholder: _vm.$t("calendar.enterLongitude"),
                          },
                          domProps: { value: _vm.data.address.longitude },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "address.longitude",
                                _vm.data.address.longitude
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.address,
                                "longitude",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "builder-section" }, [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(_vm._s(_vm.$t("calendar.contactDetails"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-content" }, [
                        _c("label", { attrs: { for: "phone" } }, [
                          _vm._v(_vm._s(_vm.$t("whatsappChannel.phoneNummer"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.contactInfo.phone,
                              expression: "data.contactInfo.phone",
                            },
                          ],
                          attrs: {
                            id: "phone",
                            type: "text",
                            placeholder: _vm.$t("calendar.enterPhoneNumber"),
                          },
                          domProps: { value: _vm.data.contactInfo.phone },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "contactInfo.phone",
                                _vm.data.contactInfo.phone
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.contactInfo,
                                "phone",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "email" } }, [
                          _vm._v(_vm._s(_vm.$t("calendar.emailAddress"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.contactInfo.email,
                              expression: "data.contactInfo.email",
                            },
                          ],
                          attrs: {
                            id: "email",
                            type: "email",
                            placeholder: _vm.$t("calendar.enterEmail"),
                          },
                          domProps: { value: _vm.data.contactInfo.email },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "contactInfo.email",
                                _vm.data.contactInfo.email
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.contactInfo,
                                "email",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "website" } }, [
                          _vm._v(_vm._s(_vm.$t("calendar.websiteURL"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.contactInfo.website,
                              expression: "data.contactInfo.website",
                            },
                          ],
                          attrs: {
                            id: "website",
                            type: "text",
                            placeholder: _vm.$t("calendar.enterWebsiteURL"),
                          },
                          domProps: { value: _vm.data.contactInfo.website },
                          on: {
                            change: function ($event) {
                              return _vm.updateField(
                                "contactInfo.website",
                                _vm.data.contactInfo.website
                              )
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data.contactInfo,
                                "website",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("section", { staticClass: "builder-section" }, [
                      _c("h2", { staticClass: "section-title" }, [
                        _vm._v(_vm._s(_vm.$t("calendar.reservationPolicy"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "section-content" },
                        [
                          _c("quill-editor", {
                            staticClass: "quill-editor",
                            attrs: {
                              options: _vm.editorOption,
                              placeholder: _vm.$t("calendar.enterResPolicy"),
                            },
                            model: {
                              value: _vm.data.reservationPolicy,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "reservationPolicy", $$v)
                              },
                              expression: "data.reservationPolicy",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "section",
                      { staticClass: "builder-section working-hours" },
                      [
                        _c("h2", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(_vm.$t("calendar.workingHours"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "section-content" }, [
                          _c(
                            "div",
                            { staticClass: "rules" },
                            [
                              _c(
                                "div",
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("message.timezone"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "250px" },
                                      attrs: {
                                        "show-search": "",
                                        placeholder: _vm.$t(
                                          "message.selectTimezone"
                                        ),
                                        "option-filter-prop": "children",
                                        "filter-option": _vm.filterOption,
                                        value: _vm.data.availability.timezone,
                                      },
                                      on: { change: _vm.changeTimezone },
                                    },
                                    _vm._l(_vm.timezones, function (tz, i) {
                                      return _c(
                                        "a-select-option",
                                        { key: i, attrs: { value: tz } },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(tz) +
                                              "\n                                        "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.data.availability.rules,
                                function (rule) {
                                  return _c(
                                    "div",
                                    { key: rule._id, staticClass: "ruleItem" },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "120px" },
                                          attrs: {
                                            "show-search": "",
                                            placeholder: _vm.$t(
                                              "message.selectDayys"
                                            ),
                                            "option-filter-prop": "children",
                                            "filter-option": _vm.filterOption,
                                            value: _vm.daysHashcode(rule.days),
                                          },
                                          on: {
                                            change: function (e) {
                                              return _vm.handleDayChange(
                                                e,
                                                rule._id
                                              )
                                            },
                                          },
                                        },
                                        _vm._l(_vm.days, function (day, i) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: i,
                                              attrs: {
                                                value: _vm.daysHashcode(
                                                  day.value
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    day.label[_vm.$i18n.locale]
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("From")]),
                                      _vm._v(" "),
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: {
                                            width: "80px",
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            "show-search": "",
                                            placeholder: _vm.$t(
                                              "message.selectStartHour"
                                            ),
                                            "option-filter-prop": "children",
                                            "filter-option": _vm.filterOption,
                                            value: rule.from,
                                          },
                                          on: {
                                            change: function (e) {
                                              return _vm.handleFromHourChange(
                                                e,
                                                rule._id
                                              )
                                            },
                                          },
                                        },
                                        _vm._l(_vm.hours, function (hour, i) {
                                          return _c(
                                            "a-select-option",
                                            { key: i, attrs: { value: hour } },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(hour) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("To")]),
                                      _vm._v(" "),
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: {
                                            width: "80px",
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            "show-search": "",
                                            placeholder: _vm.$t(
                                              "message.selectEndHour"
                                            ),
                                            "option-filter-prop": "children",
                                            "filter-option": _vm.filterOption,
                                            value: rule.to,
                                          },
                                          on: {
                                            change: function (e) {
                                              return _vm.handleEndHourChange(
                                                e,
                                                rule._id
                                              )
                                            },
                                          },
                                        },
                                        _vm._l(_vm.hours, function (hour, i) {
                                          return _c(
                                            "a-select-option",
                                            { key: i, attrs: { value: hour } },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(hour) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "SupsisButton",
                                        {
                                          attrs: {
                                            icon: "",
                                            ghost: "",
                                            danger: "",
                                            xxsmal: "",
                                            disabled:
                                              _vm.data.availability.rules
                                                .length === 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteHour(rule._id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("delete")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "btnAddHour",
                                  attrs: { type: "primary", ghost: "" },
                                  on: { click: _vm.addHour },
                                },
                                [
                                  _vm._v(
                                    "\n                                    + " +
                                      _vm._s(_vm.$t("calendar.addNewHour")) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
            _vm._v(" "),
            _vm.editingMemberIndex !== null
              ? _c(
                  "Modal2",
                  {
                    attrs: { "show-footer": true },
                    on: { cancel: _vm.cancelEdit, ok: _vm.saveEdit },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                _vm._s(_vm.$t("calendar.updateMemberInfo"))
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1676614802
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "member-update-form" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "avatar-upload",
                            on: { click: _vm.selectAvatar },
                          },
                          [
                            _vm.editingMember.avatar
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.getAvatarUrl(
                                      _vm.editingMember.avatar
                                    ),
                                    alt: "Avatar",
                                  },
                                })
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("calendar.uploadAvatar"))
                                  ),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.editingMember.name,
                              expression: "editingMember.name",
                            },
                          ],
                          attrs: { placeholder: _vm.$t("message.name") },
                          domProps: { value: _vm.editingMember.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.editingMember,
                                "name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.editingMember.title,
                              expression: "editingMember.title",
                            },
                          ],
                          attrs: { placeholder: _vm.$t("message.title") },
                          domProps: { value: _vm.editingMember.title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.editingMember,
                                "title",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("quill-editor", {
                          attrs: {
                            options: _vm.editorOption,
                            placeholder: _vm.$t("message.description"),
                          },
                          model: {
                            value: _vm.editingMember.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.editingMember, "description", $$v)
                            },
                            expression: "editingMember.description",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-content" },
                          [
                            _vm._l(
                              _vm.editingMember.plans,
                              function (plan, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "plan-group" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "plan-header",
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-flex gap-5 align-center",
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("event")]
                                            ),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(_vm.getPlanName(plan)) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "SupsisButton",
                                          {
                                            attrs: { ghost: "", danger: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removePlanFromMember(
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t("message.delete")
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c("CustomPicker", {
                              attrs: {
                                items: _vm.allPlans,
                                idKey: "_id",
                                labelKey: "title",
                                title: _vm.$t("calendar.selectReservationPlan"),
                              },
                              on: { input: _vm.addPlanToMember },
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }